<template>
  <div>
    <!--
            component ini dipakai di:
                views/kependudukan/AkunPenduduk.vue
                views/desa/InputPermohonan.vue
        -->
    <div class="form-group">
      <div class="input-group mb-3">
        <input
          type="text"
          id="search_penduduk"
          class="form-control"
          v-model="sfPenduduk"
          placeholder="Cari dengan Nama Lengkap/NIK"
        >
        <div class="input-group-append">
          <button
            id="btnSearchPenduduk"
            class="btn btn-primary"
            type="button"
            @click="searchPenduduk"
          >
            <i class="fa fa-search" />
          </button>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>No.</th>
            <th>Nama Lengkap</th>
            <th>NIK</th>
            <th>No KK</th>
            <th>Desa</th>
            <th>Pilih</th>
          </tr>
        </thead>
        <tbody v-if="tbSPenduduk.length > 0">
          <tr
            v-for="(p, i) in tbSPenduduk"
            :key="p.id_penduduk"
          >
            <td>{{ i+1 }}</td>
            <td>{{ p.nama_lengkap }}</td>
            <td>{{ p.nik }}</td>
            <td>{{ p.no_kk }}</td>
            <td>
              {{ p.desa.nama_desa }}, {{ p.desa.nama_kecamatan }} <br>
              <span
                v-if="p.is_non_permanen"
                class="badge badge-dark mt-1"
              >Non Permanen</span>
            </td>
            <td>
              <button
                class="btn btn-success btn-sm"
                @click="pilihPenduduk(p)"
                :title="'Pilih '+p.nama_lengkap"
              >
                <i class="fa fa-check mr-2" />Pilih
              </button>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td
              colspan="6"
              class="text-center"
            >
              Tidak ada data
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import NProgress from 'nprogress'
import swal from 'sweetalert'

export default {
    data() {
        return {
            sfPenduduk: '', // search form
            tbSPenduduk: [], // table search penduduk
        }
    },
    methods: {
        searchPenduduk(){
            NProgress.start()
            let button = document.querySelector('#btnSearchPenduduk')
            let buttonHtml = button.innerHTML

            button.setAttribute('disabled', true)
            button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>'

            this.$store.dispatch('searchPenduduk', this.sfPenduduk).then(res => {
                if(res.data.status){
                    this.tbSPenduduk = res.data.data

                    button.removeAttribute('disabled')
                    button.innerHTML = buttonHtml
                    setTimeout(() => NProgress.done(), 500)
                } else {
                    swal({
                        title: "Gagal",
                        text: res.data.message,
                        icon: "error",
                        buttons: "Ok"
                    })
                    setTimeout(() => NProgress.done(), 500)
                }
            })
            .catch(err => {
                swal({
                    title: "Gagal",
                    text: "Ada kesalahan teknis. Harap hubungi operator",
                    icon: "error",
                    buttons: "Ok"
                })
                setTimeout(() => NProgress.done(), 500)
            })
        },
        pilihPenduduk(data){
            this.$emit('pilihPenduduk', data)

            // reset
            this.tbSPenduduk = []
            this.sfPenduduk = ''
        }
    }
}
</script>